/* Ink siblings (18 Oct 2026): a swatch drawn by snippets/pp-ink.liquid belongs to another
   product of the same design printed in a different ink. Its link already opens that
   product on that colour; this adds the shopper's other picks (size) on the way, the
   same way the Temple / Map dropdown does. Without this script the link still works. */
(function () {
  if (window.ppInkReady) return;
  window.ppInkReady = true;

  // The page's option values by name, read from the theme's own picker (pp-mine keeps it
  // in step with the bundle panel).
  function picked() {
    var out = {};
    var vs = document.querySelector('variant-selects');
    if (!vs) return out;
    var bare = (n) => n.replace(/^options\[(.+)\]$/, '$1');
    vs.querySelectorAll('input[type="radio"]:checked').forEach((r) => { out[bare(r.name)] = r.value; });
    vs.querySelectorAll('select').forEach((s) => { out[bare(s.name)] = s.value; });
    return out;
  }

  document.addEventListener('click', (e) => {
    var a = e.target.closest('a[data-pp-ink]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var node = document.querySelector('script[data-pp-ink-variants="' + a.dataset.ppInk + '"]');
    if (!node) return;
    var p;
    try { p = JSON.parse(node.textContent); } catch (err) { return; }
    var want = picked();
    want[p.colour] = a.dataset.value;
    var fits = (v) => p.options.every((n, i) => !want[n] || v.o[i] === want[n]);
    var ci = p.options.indexOf(p.colour);
    var colourOnly = (v) => v.o[ci] === a.dataset.value;
    var v = p.variants.find((x) => fits(x) && x.a) || p.variants.find(fits) ||
      p.variants.find((x) => colourOnly(x) && x.a);
    if (!v) return;
    e.preventDefault();
    window.location.href = a.pathname + '?variant=' + v.id;
  });
})();
